export function HomeOutlineIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20964 2.91663C2.91797 2.91663 2.91797 3.08996 2.91797 5.20829V5.22913C2.91797 6.15163 2.91797 6.81829 3.1438 7.09996C3.36464 7.37329 4.02047 7.49996 5.20964 7.49996C6.3988 7.49996 7.05464 7.37246 7.27547 7.09913C7.5013 6.81829 7.5013 6.15163 7.5013 5.22829C7.5013 3.08996 7.5013 2.91663 5.20964 2.91663ZM5.20964 8.74996C3.80464 8.74996 2.75047 8.60246 2.1713 7.88329C1.66797 7.25913 1.66797 6.40746 1.66797 5.22913L2.29297 5.20829H1.66797C1.66797 2.81663 1.8188 1.66663 5.20964 1.66663C8.60047 1.66663 8.7513 2.81663 8.7513 5.20829C8.7513 6.40663 8.7513 7.25913 8.24797 7.88329C7.6688 8.60246 6.61464 8.74996 5.20964 8.74996Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3776 2.91663C12.0859 2.91663 12.0859 3.08996 12.0859 5.20829V5.22913C12.0859 6.15163 12.0859 6.81829 12.3118 7.09996C12.5326 7.37329 13.1884 7.49996 14.3776 7.49996C15.5668 7.49996 16.2226 7.37246 16.4434 7.09913C16.6693 6.81829 16.6693 6.15163 16.6693 5.22829C16.6693 3.08996 16.6693 2.91663 14.3776 2.91663ZM14.3776 8.74996C12.9726 8.74996 11.9184 8.60246 11.3393 7.88329C10.8359 7.25913 10.8359 6.40746 10.8359 5.22913L11.4609 5.20829H10.8359C10.8359 2.81663 10.9868 1.66663 14.3776 1.66663C17.7684 1.66663 17.9193 2.81663 17.9193 5.20829C17.9193 6.40663 17.9193 7.25913 17.4159 7.88329C16.8368 8.60246 15.7826 8.74996 14.3776 8.74996Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20964 12.0833C2.91797 12.0833 2.91797 12.2566 2.91797 14.3749V14.3958C2.91797 15.3183 2.91797 15.9849 3.1438 16.2666C3.36464 16.5399 4.02047 16.6666 5.20964 16.6666C6.3988 16.6666 7.05464 16.5391 7.27547 16.2658C7.5013 15.9849 7.5013 15.3183 7.5013 14.3949C7.5013 12.2566 7.5013 12.0833 5.20964 12.0833ZM5.20964 17.9166C3.80464 17.9166 2.75047 17.7691 2.1713 17.0499C1.66797 16.4258 1.66797 15.5741 1.66797 14.3958L2.29297 14.3749H1.66797C1.66797 11.9833 1.8188 10.8333 5.20964 10.8333C8.60047 10.8333 8.7513 11.9833 8.7513 14.3749C8.7513 15.5733 8.7513 16.4258 8.24797 17.0499C7.6688 17.7691 6.61464 17.9166 5.20964 17.9166Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3776 12.0833C12.0859 12.0833 12.0859 12.2566 12.0859 14.3749V14.3958C12.0859 15.3183 12.0859 15.9849 12.3118 16.2666C12.5326 16.5399 13.1884 16.6666 14.3776 16.6666C15.5668 16.6666 16.2226 16.5391 16.4434 16.2658C16.6693 15.9849 16.6693 15.3183 16.6693 14.3949C16.6693 12.2566 16.6693 12.0833 14.3776 12.0833ZM14.3776 17.9166C12.9726 17.9166 11.9184 17.7691 11.3393 17.0499C10.8359 16.4258 10.8359 15.5741 10.8359 14.3958L11.4609 14.3749H10.8359C10.8359 11.9833 10.9868 10.8333 14.3776 10.8333C17.7684 10.8333 17.9193 11.9833 17.9193 14.3749C17.9193 15.5733 17.9193 16.4258 17.4159 17.0499C16.8368 17.7691 15.7826 17.9166 14.3776 17.9166Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HomeFillIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3776 17.9166C12.9726 17.9166 11.9184 17.7691 11.3393 17.0499C10.8359 16.4258 10.8359 15.5532 10.8359 14.3749C10.8359 11.9833 10.9868 10.8333 14.3776 10.8333C17.7684 10.8333 17.9193 11.9833 17.9193 14.3749C17.9193 15.5733 17.9193 16.4258 17.4159 17.0499C16.8368 17.7691 15.7826 17.9166 14.3776 17.9166Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20961 17.9166C3.80461 17.9166 2.75041 17.7691 2.17131 17.0499C1.66791 16.4258 1.66791 15.5532 1.66791 14.3749C1.66791 11.9833 1.81881 10.8333 5.20961 10.8333C8.60041 10.8333 8.75131 11.9833 8.75131 14.3749C8.75131 15.5733 8.75131 16.4258 8.24791 17.0499C7.66881 17.7691 6.61461 17.9166 5.20961 17.9166Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20961 8.74993C3.80461 8.74993 2.75041 8.60243 2.17131 7.88323C1.66791 7.25913 1.66791 6.38653 1.66791 5.20823C1.66791 2.81663 1.81881 1.66663 5.20961 1.66663C8.60041 1.66663 8.75131 2.81663 8.75131 5.20823C8.75131 6.40663 8.75131 7.25913 8.24791 7.88323C7.66881 8.60243 6.61461 8.74993 5.20961 8.74993Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3776 8.75005C12.9726 8.75005 11.9184 8.60255 11.3393 7.88335C10.8359 7.25925 10.8359 6.38665 10.8359 5.20835C10.8359 2.81675 10.9868 1.66675 14.3776 1.66675C17.7684 1.66675 17.9193 2.81675 17.9193 5.20835C17.9193 6.40675 17.9193 7.25925 17.4159 7.88335C16.8368 8.60255 15.7826 8.75005 14.3776 8.75005Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function OfferingsOutlineIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_601_875)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8929 15.8917C13.3461 18.4387 9.57489 18.989 6.48876 17.5618C6.03317 17.3784 5.65965 17.2301 5.30456 17.2301C4.31549 17.236 3.08439 18.195 2.44455 17.5559C1.80471 16.916 2.76447 15.684 2.76447 14.6889C2.76447 14.3338 2.62209 13.9669 2.43869 13.5104C1.01077 10.4248 1.56184 6.65232 4.10863 4.10609C7.35975 0.853774 12.6418 0.853774 15.8929 4.10525C19.1499 7.36259 19.144 12.6402 15.8929 15.8917Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.6034 9.88867C7.30531 8.95803 7.47977 7.89432 8.4568 7.57957C8.97074 7.41372 9.86189 7.8089 10.1377 8.56259C10.4153 7.80856 11.3286 7.41483 11.8419 7.57957C12.819 7.89432 12.9725 8.95803 12.6747 9.88867C12.2108 11.3638 10.1392 12.5 10.1392 12.5C10.1392 12.5 8.08289 11.381 7.6034 9.88867Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_601_875">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function OfferingsFillIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_601_917)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8929 15.8917C13.3461 18.4387 9.57489 18.989 6.48876 17.5618C6.03317 17.3784 5.65965 17.2301 5.30456 17.2301C4.31549 17.236 3.08439 18.195 2.44455 17.5559C1.80471 16.916 2.76447 15.684 2.76447 14.6889C2.76447 14.3338 2.62209 13.9669 2.43869 13.5104C1.01077 10.4248 1.56184 6.65232 4.10863 4.10609C7.35975 0.853774 12.6418 0.853774 15.8929 4.10525C19.1499 7.36259 19.144 12.6402 15.8929 15.8917Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.6034 9.88867C7.30531 8.95803 7.47977 7.89432 8.4568 7.57957C8.97074 7.41372 9.86189 7.8089 10.1377 8.56259C10.4153 7.80856 11.3286 7.41483 11.8419 7.57957C12.819 7.89432 12.9725 8.95803 12.6747 9.88867C12.2108 11.3638 10.1392 12.5 10.1392 12.5C10.1392 12.5 8.08289 11.381 7.6034 9.88867Z"
          fill="#E9E9EB"
          stroke="#E9E9EB"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_601_917">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SettingsOutlineIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_601_881"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="17"
        height="18"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66797 1.66699H17.7387V18.9345H1.66797V1.66699Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_601_881)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00324 14.5337C6.19407 14.5337 6.3849 14.5578 6.57157 14.6078C7.1349 14.7595 7.62407 15.1362 7.91407 15.642C8.1024 15.9595 8.20657 16.3303 8.2099 16.7087C8.2099 17.2503 8.6449 17.6845 9.1799 17.6845H10.2241C10.7566 17.6845 11.1916 17.2528 11.1941 16.7203C11.1907 16.132 11.4207 15.5728 11.8416 15.152C12.2566 14.737 12.8366 14.4878 13.4166 14.5045C13.7966 14.5137 14.1624 14.6162 14.4849 14.7995C14.9491 15.0653 15.5416 14.907 15.8099 14.4487L16.3632 13.5262C16.4866 13.3137 16.5224 13.047 16.4566 12.8012C16.3916 12.5553 16.2282 12.342 16.0082 12.2162C15.4932 11.9195 15.1257 11.4412 14.9732 10.8678C14.8224 10.3053 14.9049 9.69116 15.1991 9.18533C15.3907 8.85199 15.6716 8.57116 16.0082 8.37783C16.4599 8.11366 16.6182 7.52283 16.3557 7.06283C16.3449 7.04449 16.3349 7.02533 16.3266 7.00533L15.8382 6.15866C15.5724 5.69616 14.9807 5.53699 14.5166 5.80116C14.0149 6.09783 13.4182 6.18283 12.8449 6.03199C12.2724 5.88366 11.7924 5.52116 11.4932 5.00949C11.3016 4.68949 11.1974 4.31699 11.1941 3.93783C11.2016 3.65283 11.1016 3.39699 10.9199 3.20949C10.7391 3.02283 10.4849 2.91699 10.2241 2.91699H9.1799C8.92157 2.91699 8.6799 3.01783 8.4974 3.19949C8.31574 3.38199 8.21657 3.62449 8.21824 3.88283C8.20074 5.10116 7.2049 6.08199 5.99907 6.08199C5.6124 6.07783 5.2399 5.97366 4.91657 5.78033C4.4624 5.52199 3.86907 5.68116 3.60324 6.14366L3.03907 7.07116C2.78074 7.51949 2.93907 8.11199 3.39907 8.37949C4.08157 8.77449 4.5074 9.51116 4.5074 10.3012C4.5074 11.0912 4.08157 11.827 3.3974 12.2228C2.9399 12.4878 2.78157 13.077 3.04657 13.5353L3.5724 14.442C3.7024 14.6762 3.9149 14.8453 4.16074 14.9145C4.40574 14.9828 4.67574 14.9537 4.90074 14.8287C5.23157 14.6345 5.61657 14.5337 6.00324 14.5337ZM10.2241 18.9345H9.1799C7.95574 18.9345 6.9599 17.9395 6.9599 16.7153C6.95824 16.5645 6.9149 16.4078 6.83407 16.272C6.70324 16.0437 6.49157 15.8803 6.2474 15.8153C6.0049 15.7503 5.73907 15.7862 5.52074 15.9128C4.9974 16.2045 4.38157 16.2753 3.81824 16.117C3.25574 15.9578 2.7699 15.5712 2.4849 15.0587L1.96407 14.1612C1.3549 13.1045 1.7174 11.7503 2.7724 11.1403C3.07157 10.9678 3.2574 10.6462 3.2574 10.3012C3.2574 9.95616 3.07157 9.63366 2.7724 9.46116C1.71657 8.84783 1.3549 7.49033 1.96324 6.43366L2.52824 5.50616C3.12907 4.46116 4.4874 4.09283 5.54657 4.70116C5.69074 4.78699 5.8474 4.83033 6.00657 4.83199C6.52574 4.83199 6.9599 4.40366 6.96824 3.87699C6.9649 3.29616 7.19407 2.73866 7.61157 2.31783C8.03074 1.89783 8.5874 1.66699 9.1799 1.66699H10.2241C10.8207 1.66699 11.4007 1.91199 11.8166 2.33783C12.2316 2.76616 12.4607 3.35366 12.4432 3.94949C12.4449 4.08366 12.4891 4.23866 12.5691 4.37449C12.7016 4.59949 12.9107 4.75783 13.1591 4.82283C13.4074 4.88449 13.6674 4.85116 13.8882 4.72033C14.9549 4.11116 16.3124 4.47616 16.9216 5.53449L17.4407 6.43366C17.4541 6.45783 17.4657 6.48116 17.4757 6.50533C18.0274 7.54783 17.6591 8.86033 16.6341 9.45949C16.4849 9.54533 16.3641 9.66533 16.2807 9.81033C16.1516 10.0345 16.1157 10.3012 16.1807 10.5462C16.2474 10.7962 16.4066 11.0037 16.6307 11.132C17.1366 11.4228 17.5141 11.9128 17.6649 12.4787C17.8157 13.0437 17.7332 13.657 17.4391 14.1628L16.8857 15.0845C16.2766 16.1312 14.9191 16.4937 13.8632 15.8837C13.7224 15.8028 13.5599 15.7587 13.3982 15.7545H13.3932C13.1524 15.7545 12.9049 15.857 12.7249 16.0362C12.5424 16.2187 12.4424 16.462 12.4441 16.7203C12.4382 17.9445 11.4424 18.9345 10.2241 18.9345Z"
          fill="currentColor"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70448 8.72876C8.83781 8.72876 8.13281 9.43459 8.13281 10.3013C8.13281 11.1679 8.83781 11.8721 9.70448 11.8721C10.5711 11.8721 11.2761 11.1679 11.2761 10.3013C11.2761 9.43459 10.5711 8.72876 9.70448 8.72876ZM9.70448 13.1221C8.14865 13.1221 6.88281 11.8571 6.88281 10.3013C6.88281 8.74543 8.14865 7.47876 9.70448 7.47876C11.2603 7.47876 12.5261 8.74543 12.5261 10.3013C12.5261 11.8571 11.2603 13.1221 9.70448 13.1221Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SettingsFillIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00324 14.5337C6.19407 14.5337 6.3849 14.5578 6.57157 14.6078C7.1349 14.7595 7.62407 15.1362 7.91407 15.642C8.1024 15.9595 8.20657 16.3303 8.2099 16.7087C8.2099 17.2503 8.6449 17.6845 9.1799 17.6845H10.2241C10.7566 17.6845 11.1916 17.2528 11.1941 16.7203C11.1907 16.132 11.4207 15.5728 11.8416 15.152C12.2566 14.737 12.8366 14.4878 13.4166 14.5045C13.7966 14.5137 14.1624 14.6162 14.4849 14.7995C14.9491 15.0653 15.5416 14.907 15.8099 14.4487L16.3632 13.5262C16.4866 13.3137 16.5224 13.047 16.4566 12.8012C16.3916 12.5553 16.2282 12.342 16.0082 12.2162C15.4932 11.9195 15.1257 11.4412 14.9732 10.8678C14.8224 10.3053 14.9049 9.69116 15.1991 9.18533C15.3907 8.85199 15.6716 8.57116 16.0082 8.37783C16.4599 8.11366 16.6182 7.52283 16.3557 7.06283C16.3449 7.04449 16.3349 7.02533 16.3266 7.00533L15.8382 6.15866C15.5724 5.69616 14.9807 5.53699 14.5166 5.80116C14.0149 6.09783 13.4182 6.18283 12.8449 6.03199C12.2724 5.88366 11.7924 5.52116 11.4932 5.00949C11.3016 4.68949 11.1974 4.31699 11.1941 3.93783C11.2016 3.65283 11.1016 3.39699 10.9199 3.20949C10.7391 3.02283 10.4849 2.91699 10.2241 2.91699H9.1799C8.92157 2.91699 8.6799 3.01783 8.4974 3.19949C8.31574 3.38199 8.21657 3.62449 8.21824 3.88283C8.20074 5.10116 7.2049 6.08199 5.99907 6.08199C5.6124 6.07783 5.2399 5.97366 4.91657 5.78033C4.4624 5.52199 3.86907 5.68116 3.60324 6.14366L3.03907 7.07116C2.78074 7.51949 2.93907 8.11199 3.39907 8.37949C4.08157 8.77449 4.5074 9.51116 4.5074 10.3012C4.5074 11.0912 4.08157 11.827 3.3974 12.2228C2.9399 12.4878 2.78157 13.077 3.04657 13.5353L3.5724 14.442C3.7024 14.6762 3.9149 14.8453 4.16074 14.9145C4.40574 14.9828 4.67574 14.9537 4.90074 14.8287C5.23157 14.6345 5.61657 14.5337 6.00324 14.5337ZM10.2241 18.9345H9.1799C7.95574 18.9345 6.9599 17.9395 6.9599 16.7153C6.95824 16.5645 6.9149 16.4078 6.83407 16.272C6.70324 16.0437 6.49157 15.8803 6.2474 15.8153C6.0049 15.7503 5.73907 15.7862 5.52074 15.9128C4.9974 16.2045 4.38157 16.2753 3.81824 16.117C3.25574 15.9578 2.7699 15.5712 2.4849 15.0587L1.96407 14.1612C1.3549 13.1045 1.7174 11.7503 2.7724 11.1403C3.07157 10.9678 3.2574 10.6462 3.2574 10.3012C3.2574 9.95616 3.07157 9.63366 2.7724 9.46116C2.06388 9.04958 1.66795 8.30289 1.66797 7.53687C1.66798 7.16138 1.76313 6.78124 1.96324 6.43366L2.52824 5.50616C3.12907 4.46116 4.4874 4.09283 5.54657 4.70116C5.69074 4.78699 5.8474 4.83033 6.00657 4.83199C6.52574 4.83199 6.9599 4.40366 6.96824 3.87699C6.9649 3.29616 7.19407 2.73866 7.61157 2.31783C8.03074 1.89783 8.5874 1.66699 9.1799 1.66699H10.2241C10.8207 1.66699 11.4007 1.91199 11.8166 2.33783C12.2316 2.76616 12.4607 3.35366 12.4432 3.94949C12.4449 4.08366 12.4891 4.23866 12.5691 4.37449C12.7016 4.59949 12.9107 4.75783 13.1591 4.82283C13.4074 4.88449 13.6674 4.85116 13.8882 4.72033C14.9549 4.11116 16.3124 4.47616 16.9216 5.53449L17.4407 6.43366C17.4541 6.45783 17.4657 6.48116 17.4757 6.50533C18.0274 7.54783 17.6591 8.86033 16.6341 9.45949C16.4849 9.54533 16.3641 9.66533 16.2807 9.81033C16.1516 10.0345 16.1157 10.3012 16.1807 10.5462C16.2474 10.7962 16.4066 11.0037 16.6307 11.132C17.1366 11.4228 17.5141 11.9128 17.6649 12.4787C17.713 12.659 17.7374 12.8443 17.7387 13.0294C17.7388 13.0399 17.7388 13.0503 17.7387 13.0608C17.736 13.4451 17.634 13.8276 17.4391 14.1628L16.8857 15.0845C16.2766 16.1312 14.9191 16.4937 13.8632 15.8837C13.7224 15.8028 13.5599 15.7587 13.3982 15.7545H13.3932C13.1524 15.7545 12.9049 15.857 12.7249 16.0362C12.5424 16.2187 12.4424 16.462 12.4441 16.7203C12.4382 17.9445 11.4424 18.9345 10.2241 18.9345Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70448 8.72876C8.83781 8.72876 8.13281 9.43459 8.13281 10.3013C8.13281 11.1679 8.83781 11.8721 9.70448 11.8721C10.5711 11.8721 11.2761 11.1679 11.2761 10.3013C11.2761 9.43459 10.5711 8.72876 9.70448 8.72876ZM9.70448 13.1221C8.14865 13.1221 6.88281 11.8571 6.88281 10.3013C6.88281 8.74543 8.14865 7.47876 9.70448 7.47876C11.2603 7.47876 12.5261 8.74543 12.5261 10.3013C12.5261 11.8571 11.2603 13.1221 9.70448 13.1221Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1799 1.66699H10.2241C10.8207 1.66699 11.4007 1.91199 11.8166 2.33783C12.2316 2.76616 12.4607 3.35366 12.4432 3.94949C12.4449 4.08366 12.4891 4.23866 12.5691 4.37449C12.7016 4.59949 12.9107 4.75783 13.1591 4.82283C13.4074 4.88449 13.6674 4.85116 13.8882 4.72033C14.9549 4.11116 16.3124 4.47616 16.9216 5.53449L17.4407 6.43366C17.4541 6.45783 17.4657 6.48116 17.4757 6.50533C18.0274 7.54783 17.6591 8.86033 16.6341 9.45949C16.4849 9.54533 16.3641 9.66533 16.2807 9.81033C16.1516 10.0345 16.1157 10.3012 16.1807 10.5462C16.2474 10.7962 16.4066 11.0037 16.6307 11.132C17.1366 11.4228 17.5141 11.9128 17.6649 12.4787C17.713 12.659 17.7374 12.8443 17.7387 13.0294V13.0608C17.736 13.4451 17.634 13.8276 17.4391 14.1628L16.8857 15.0845C16.2766 16.1312 14.9191 16.4937 13.8632 15.8837C13.7224 15.8028 13.5599 15.7587 13.3982 15.7545H13.3932C13.1524 15.7545 12.9049 15.857 12.7249 16.0362C12.5424 16.2187 12.4424 16.462 12.4441 16.7203C12.4382 17.9445 11.4424 18.9345 10.2241 18.9345H9.1799C7.95574 18.9345 6.9599 17.9395 6.9599 16.7153C6.95824 16.5645 6.9149 16.4078 6.83407 16.272C6.70324 16.0437 6.49157 15.8803 6.2474 15.8153C6.0049 15.7503 5.73907 15.7862 5.52074 15.9128C4.9974 16.2045 4.38157 16.2753 3.81824 16.117C3.25574 15.9578 2.7699 15.5712 2.4849 15.0587L1.96407 14.1612C1.3549 13.1045 1.7174 11.7503 2.7724 11.1403C3.07157 10.9678 3.2574 10.6462 3.2574 10.3012C3.2574 9.95616 3.07157 9.63366 2.7724 9.46116C2.06388 9.04958 1.66795 8.30289 1.66797 7.53687C1.66798 7.16138 1.76313 6.78124 1.96324 6.43366L2.52824 5.50616C3.12907 4.46116 4.4874 4.09283 5.54657 4.70116C5.69074 4.78699 5.8474 4.83033 6.00657 4.83199C6.52574 4.83199 6.9599 4.40366 6.96824 3.87699C6.9649 3.29616 7.19407 2.73866 7.61157 2.31783C8.03074 1.89783 8.5874 1.66699 9.1799 1.66699ZM6.00324 14.5337C6.19407 14.5337 6.3849 14.5578 6.57157 14.6078C7.1349 14.7595 7.62407 15.1362 7.91407 15.642C8.1024 15.9595 8.20657 16.3303 8.2099 16.7087C8.2099 17.2503 8.6449 17.6845 9.1799 17.6845H10.2241C10.7566 17.6845 11.1916 17.2528 11.1941 16.7203C11.1907 16.132 11.4207 15.5728 11.8416 15.152C12.2566 14.737 12.8366 14.4878 13.4166 14.5045C13.7966 14.5137 14.1624 14.6162 14.4849 14.7995C14.9491 15.0653 15.5416 14.907 15.8099 14.4487L16.3632 13.5262C16.4866 13.3137 16.5224 13.047 16.4566 12.8012C16.3916 12.5553 16.2282 12.342 16.0082 12.2162C15.4932 11.9195 15.1257 11.4412 14.9732 10.8678C14.8224 10.3053 14.9049 9.69116 15.1991 9.18533C15.3907 8.85199 15.6716 8.57116 16.0082 8.37783C16.4599 8.11366 16.6182 7.52283 16.3557 7.06283C16.3449 7.04449 16.3349 7.02533 16.3266 7.00533L15.8382 6.15866C15.5724 5.69616 14.9807 5.53699 14.5166 5.80116C14.0149 6.09783 13.4182 6.18283 12.8449 6.03199C12.2724 5.88366 11.7924 5.52116 11.4932 5.00949C11.3016 4.68949 11.1974 4.31699 11.1941 3.93783C11.2016 3.65283 11.1016 3.39699 10.9199 3.20949C10.7391 3.02283 10.4849 2.91699 10.2241 2.91699H9.1799C8.92157 2.91699 8.6799 3.01783 8.4974 3.19949C8.31574 3.38199 8.21657 3.62449 8.21824 3.88283C8.20074 5.10116 7.2049 6.08199 5.99907 6.08199C5.6124 6.07783 5.2399 5.97366 4.91657 5.78033C4.4624 5.52199 3.86907 5.68116 3.60324 6.14366L3.03907 7.07116C2.78074 7.51949 2.93907 8.11199 3.39907 8.37949C4.08157 8.77449 4.5074 9.51116 4.5074 10.3012C4.5074 11.0912 4.08157 11.827 3.3974 12.2228C2.9399 12.4878 2.78157 13.077 3.04657 13.5353L3.5724 14.442C3.7024 14.6762 3.9149 14.8453 4.16074 14.9145C4.40574 14.9828 4.67574 14.9537 4.90074 14.8287C5.23157 14.6345 5.61657 14.5337 6.00324 14.5337ZM6.88281 10.3013C6.88281 11.8571 8.14865 13.1221 9.70448 13.1221C11.2603 13.1221 12.5261 11.8571 12.5261 10.3013C12.5261 8.74543 11.2603 7.47876 9.70448 7.47876C8.14865 7.47876 6.88281 8.74543 6.88281 10.3013ZM8.13281 10.3013C8.13281 9.43459 8.83781 8.72876 9.70448 8.72876C10.5711 8.72876 11.2761 9.43459 11.2761 10.3013C11.2761 11.1679 10.5711 11.8721 9.70448 11.8721C8.83781 11.8721 8.13281 11.1679 8.13281 10.3013Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00324 14.5337C6.19407 14.5337 6.3849 14.5578 6.57157 14.6078C7.1349 14.7595 7.62407 15.1362 7.91407 15.642C8.1024 15.9595 8.20657 16.3303 8.2099 16.7087C8.2099 17.2503 8.6449 17.6845 9.1799 17.6845H10.2241C10.7566 17.6845 11.1916 17.2528 11.1941 16.7203C11.1907 16.132 11.4207 15.5728 11.8416 15.152C12.2566 14.737 12.8366 14.4878 13.4166 14.5045C13.7966 14.5137 14.1624 14.6162 14.4849 14.7995C14.9491 15.0653 15.5416 14.907 15.8099 14.4487L16.3632 13.5262C16.4866 13.3137 16.5224 13.047 16.4566 12.8012C16.3916 12.5553 16.2282 12.342 16.0082 12.2162C15.4932 11.9195 15.1257 11.4412 14.9732 10.8678C14.8224 10.3053 14.9049 9.69116 15.1991 9.18533C15.3907 8.85199 15.6716 8.57116 16.0082 8.37783C16.4599 8.11366 16.6182 7.52283 16.3557 7.06283C16.3449 7.04449 16.3349 7.02533 16.3266 7.00533L15.8382 6.15866C15.5724 5.69616 14.9807 5.53699 14.5166 5.80116C14.0149 6.09783 13.4182 6.18283 12.8449 6.03199C12.2724 5.88366 11.7924 5.52116 11.4932 5.00949C11.3016 4.68949 11.1974 4.31699 11.1941 3.93783C11.2016 3.65283 11.1016 3.39699 10.9199 3.20949C10.7391 3.02283 10.4849 2.91699 10.2241 2.91699H9.1799C8.92157 2.91699 8.6799 3.01783 8.4974 3.19949C8.31574 3.38199 8.21657 3.62449 8.21824 3.88283C8.20074 5.10116 7.2049 6.08199 5.99907 6.08199C5.6124 6.07783 5.2399 5.97366 4.91657 5.78033C4.4624 5.52199 3.86907 5.68116 3.60324 6.14366L3.03907 7.07116C2.78074 7.51949 2.93907 8.11199 3.39907 8.37949C4.08157 8.77449 4.5074 9.51116 4.5074 10.3012C4.5074 11.0912 4.08157 11.827 3.3974 12.2228C2.9399 12.4878 2.78157 13.077 3.04657 13.5353L3.5724 14.442C3.7024 14.6762 3.9149 14.8453 4.16074 14.9145C4.40574 14.9828 4.67574 14.9537 4.90074 14.8287C5.23157 14.6345 5.61657 14.5337 6.00324 14.5337ZM6.88281 10.3013C6.88281 11.8571 8.14865 13.1221 9.70448 13.1221C11.2603 13.1221 12.5261 11.8571 12.5261 10.3013C12.5261 8.74543 11.2603 7.47876 9.70448 7.47876C8.14865 7.47876 6.88281 8.74543 6.88281 10.3013Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ProfileOutlineIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 15.3462C8.11731 15.3462 4.81445 15.931 4.81445 18.2729C4.81445 20.6148 8.09636 21.2205 11.9849 21.2205C15.8525 21.2205 19.1545 20.6348 19.1545 18.2938C19.1545 15.9529 15.8735 15.3462 11.9849 15.3462Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z"
        stroke="currentColor"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ProfileFillIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 15.3462C8.11731 15.3462 4.81445 15.931 4.81445 18.2729C4.81445 20.6148 8.09636 21.2205 11.9849 21.2205C15.8525 21.2205 19.1545 20.6348 19.1545 18.2938C19.1545 15.9529 15.8735 15.3462 11.9849 15.3462Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TransactionOutlineIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2222_11652)">
        <path
          d="M14.9996 0.713867H4.99958C2.63265 0.713867 0.713867 2.63265 0.713867 4.99958V14.9996C0.713867 17.3665 2.63265 19.2853 4.99958 19.2853H14.9996C17.3665 19.2853 19.2853 17.3665 19.2853 14.9996V4.99958C19.2853 2.63265 17.3665 0.713867 14.9996 0.713867Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9997 11.4282L12.1426 14.2853V5.71387"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 8.57101L7.85714 5.71387V14.2853"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2222_11652">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TransactionFillIcon({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_802_878)">
        <path
          d="M14.9996 0.713867H4.99958C2.63265 0.713867 0.713867 2.63265 0.713867 4.99958V14.9996C0.713867 17.3665 2.63265 19.2853 4.99958 19.2853H14.9996C17.3665 19.2853 19.2853 17.3665 19.2853 14.9996V4.99958C19.2853 2.63265 17.3665 0.713867 14.9996 0.713867Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.46387 4.99958C1.46387 3.04686 3.04686 1.46387 4.99958 1.46387H14.9996C16.9523 1.46387 18.5353 3.04686 18.5353 4.99958V14.9996C18.5353 16.9523 16.9523 18.5353 14.9996 18.5353H4.99958C3.04686 18.5353 1.46387 16.9523 1.46387 14.9996V4.99958ZM8.60714 5.71387C8.60714 5.41052 8.42441 5.13705 8.14415 5.02096C7.8639 4.90487 7.54131 4.96904 7.32681 5.18354L4.46967 8.04068C4.17678 8.33357 4.17678 8.80845 4.46967 9.10134C4.76256 9.39423 5.23744 9.39423 5.53033 9.10134L7.10714 7.52453V14.2853C7.10714 14.6995 7.44293 15.0353 7.85714 15.0353C8.27135 15.0353 8.60714 14.6995 8.60714 14.2853V5.71387ZM12.8926 5.71387C12.8926 5.29966 12.5568 4.96387 12.1426 4.96387C11.7284 4.96387 11.3926 5.29966 11.3926 5.71387V14.2853C11.3926 14.5886 11.5753 14.8621 11.8556 14.9782C12.1358 15.0943 12.4584 15.0301 12.6729 14.8156L15.53 11.9585C15.8229 11.6656 15.8229 11.1908 15.53 10.8979C15.2371 10.605 14.7623 10.605 14.4694 10.8979L12.8926 12.4746V5.71387Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_802_878">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
